import * as React from 'react';

type Props = {
  className?: string;
  children?: React.ReactNode;
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  iconComponent?: React.ReactNode;
  onClick?: React.ReactEventHandler;
};

const Typography = ({
  className,
  children,
  variant: Component,
  iconComponent,
  onClick,
}: Props) => {
  const childComponent = (
    <Component className={className} onClick={onClick}>
      {children}
    </Component>
  );
  if (!iconComponent) return childComponent;
  return (
    <div className="title-icon">
      {iconComponent}
      {childComponent}
    </div>
  );
};

export default Typography;
